import type { AgentView, LeadType, PostalPoint } from './contracts';
import { evaluateCoverage } from './routing';

export function teamZipCoverage(agents: AgentView[], postal: PostalPoint[], leadType: LeadType) {
  const points = new Map(postal.map(point => [point.zip, point]));
  const zips = new Set(points.keys());
  for (const agent of agents) for (const rule of agent.coverage.rules) {
    for (const zip of rule.shape === 'radius' ? [rule.centerZip ?? ''] : rule.zips) if (/^\d{5}$/.test(zip)) zips.add(zip);
  }
  return [...zips].sort().map(zip => {
    const matches = [...new Map(agents.map(agent => [agent.id, agent])).values()].flatMap(agent => {
      if (!agent.settings.leadTypes.includes(leadType)) return [];
      const match = evaluateCoverage(agent.coverage, { zip, point: points.get(zip) ?? null, leadType });
      return match.tier === 'preferred' || match.tier === 'backup' ? [{ agent, match }] : [];
    });
    return { zip, matches: matches.sort((a,b) => a.agent.name.localeCompare(b.agent.name)), preferred: matches.filter(m => m.match.tier === 'preferred').length, backup: matches.filter(m => m.match.tier === 'backup').length };
  }).filter(row => row.matches.length > 0);
}

// Unique covered ZIPs across the agent's enabled lead types; enrollment and FUB
// availability do not erase saved geography.
export function agentZipCount(agent: AgentView, postal: PostalPoint[]) {
  const points = new Map(postal.map(point => [point.zip, point]));
  const zips = new Set(points.keys());
  for (const rule of agent.coverage.rules) {
    for (const zip of rule.shape === 'radius' ? [rule.centerZip ?? ''] : rule.zips) if (/^\d{5}$/.test(zip)) zips.add(zip);
  }
  return [...zips].filter(zip => agent.settings.leadTypes.some(leadType => {
    const match = evaluateCoverage(agent.coverage, { zip, point: points.get(zip) ?? null, leadType });
    return match.tier === 'preferred' || match.tier === 'backup';
  })).length;
}
